module.exports = __webpack_public_path__ + "static/media/dhruv.51e393f9.jpg";